import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import React, { useMemo } from 'react'

export const CustomHeaderTooltip = ({ colDef, width, overrideValue }) => {
  const display = useMemo(
    () =>
      displayValues.find((v) => (overrideValue ? v.field === overrideValue : v.field === colDef.field))?.value ||
      (() => <Texto>{colDef.field}</Texto>),
    [overrideValue, colDef.field]
  )

  return (
    <Vertical style={{ minWidth: width, maxWidth: width }} className={'bg-1 bordered p-2 px-3'}>
      {display()}
    </Vertical>
  )
}

export const displayValues = [
  {
    field: 'terminal',
    value: () => <Texto>The name of the terminal</Texto>,
  },
  {
    field: 'name',
    value: () => (
      <>
        <Texto className={'mb-1'}>Cards required for loading and unloading activities at Terminals. </Texto>
        <Texto className={'mb-1'}>Ex. Loading Card 90, Unloading Card 120</Texto>
      </>
    ),
  },
  {
    field: 'activity',
    value: (whiteText = false) => {
      const items = [
        { label: 'Loading', description: 'References loading activity (i.e. BOLs)' },
        { label: 'Unloading', description: 'References unloading activity (i.e. Backhauls)' },
      ]
      return (
        <>
          {items.map(({ label, description }) => (
            <Horizontal key={label} className={'mb-1'}>
              <Texto appearance={whiteText ? 'white' : 'default'} className={'mr-2'}>
                {label}:{' '}
              </Texto>
              <Texto appearance={whiteText ? 'white' : 'default'}>{description}</Texto>
            </Horizontal>
          ))}
        </>
      )
    },
  },
  {
    field: 'certification_trigger',
    value: (whiteText = false) => {
      const items = [
        { label: 'Automatic - Activity Based', description: 'Certification triggers based on days between Activity.' },
        { label: 'Manual - Date Based', description: 'Certification triggers based on days certification date.' },
        {
          label: 'Never Expires',
          description:
            'Will clear Days Valid and Warning Threshold and set Dispatch Impact to "Informational (No Impact)”.',
        },
      ]
      return (
        <>
          {items.map(({ label, description }) => (
            <Horizontal key={label} className={'mb-1'}>
              <Texto appearance={whiteText ? 'white' : 'default'} className={'mr-2'}>
                {label}:{' '}
              </Texto>
              <Texto appearance={whiteText ? 'white' : 'default'}>{description}</Texto>
            </Horizontal>
          ))}
        </>
      )
    },
  },
  {
    field: 'days_valid',
    value: (whiteText = false) => {
      const items = [
        { label: 'Automatic - Activity Based', description: 'Certification triggers based on days between Activity.' },
        { label: 'Manual - Date Based', description: 'Certification triggers based on days certification date.' },
        {
          label: 'Never Expires',
          description:
            'Will clear Days Valid and Warning Threshold and set Dispatch Impact to "Informational (No Impact)”.',
        },
      ]
      return (
        <>
          <Texto className={'mb-1'}>Based on Certification Trigger</Texto>
          {items.map(({ label, description }) => (
            <Horizontal key={label} className={'mb-1'}>
              <Texto appearance={whiteText ? 'white' : 'default'} className={'mr-2'}>
                {label}:{' '}
              </Texto>
              <Texto appearance={whiteText ? 'white' : 'default'}>{description}</Texto>
            </Horizontal>
          ))}
        </>
      )
    },
  },
  {
    field: 'warning_threshold',
    value: (whiteText = false) => (
      <Texto appearance={whiteText ? 'white' : 'default'}>Days before Expiration to Trigger Warning</Texto>
    ),
  },
  {
    field: 'dispatch_impact',
    value: (whiteText = false) => {
      const items = [
        {
          label: 'Alert',
          description: 'Alert on Driver Dispatch Driver Card and can dispatch',
        },
        {
          label: 'Alert Manual, Block Optimizer',
          description: `Alert on Driver Dispatch Driver Card of manually dispatched orders but blocks auto dispatching by Route Optimizer.  Missing card or certification date will alert dispatch.`,
        },
        {
          label: 'Block',
          description: 'Blocks dispatch with error message',
        },
        {
          label: 'Informational (No Impact)',
          description: 'No alert or blocking dispatch',
        },
      ]
      return (
        <>
          {items.map((item) => (
            <Horizontal key={item.label} className={'mb-1'}>
              <Texto appearance={whiteText ? 'white' : 'default'} style={{ whiteSpace: 'nowrap' }} className={'mr-2'}>
                {item.label}:
              </Texto>
              <Texto appearance={whiteText ? 'white' : 'default'}>{item.description}</Texto>
            </Horizontal>
          ))}
        </>
      )
    },
  },

  {
    field: 'carding_instructions',
    value: (whiteText = false) => (
      <>
        <Texto appearance={whiteText ? 'white' : 'default'} className={'mb-1'}>
          Enter specific carding instructions for a card at a terminal.
        </Texto>
        <Texto appearance={whiteText ? 'white' : 'default'}>
          {' '}
          Deleting a card from a terminal will also delete the associated instructions.
        </Texto>
      </>
    ),
  },
  {
    field: 'terminal-card-actions',
    value: () => (
      <>
        <Texto className={'mb-1'}>
          Removing a Card from a Terminal will also remove it from all drivers with this card at this terminal.
        </Texto>
      </>
    ),
  },
  {
    field: 'activity_threshold',
    value: (whiteText = false) => (
      <>
        <Texto appearance={whiteText ? 'white' : 'default'}>Qty of activities before certification is approved.</Texto>
        <Texto appearance={whiteText ? 'white' : 'default'}>
          {' '}
          Only applies to "Automatic - Activity Based" Certification Triggers and must be &gt; 0
        </Texto>
        <Texto appearance={whiteText ? 'white' : 'default'}>
          If activity threshold is &gt; 1 then dispatched loads will Alert and adopt their Dispatch Impact after the
          Activity Threshold has been met.
        </Texto>
      </>
    ),
  },
]
